import {useReducer} from 'react'
import {ICompanyEnum} from '@bdswiss/common-enums'

import {AccountCardProps} from '../types'
import {reducer} from './reducer'
import {ActionType} from './actions'
import {initialState} from './initialState'
import {PammInvestorMinimumDepositRequiredPopup} from './components/Popups/PammInvestorMinimumDepositRequiredPopup'
import {toPammPortal} from './toPammPortal'
import invariant from 'tiny-invariant'
import {Account, PammTauroMarketsAccount} from '../../../../../graphql/types'
import {PammInvestorPendingPopup} from './components/Popups/PammInvestorPendingPopup'
import {PammInvestorAccountCard} from './components/PammInvestorAccountCard'

type PammTauroMarketsAccountCardProps = AccountCardProps & {
  account: PammTauroMarketsAccount,
  company: ICompanyEnum,
  restAccounts: Account[],
}

export const PammTauroMarketsAccountCard: React.FC<PammTauroMarketsAccountCardProps> = ({account, company, restAccounts}: PammTauroMarketsAccountCardProps) => {
  const [
    {
      showMinimumDepositRequiredPopup,
      showPendingPopup,
    },
    dispatch
  ] = useReducer(reducer, {...initialState, account})

  const closeModals = () => {
    dispatch({type: ActionType.CloseModal})
  }

  const accountBalance = account.balance ?? 0
  const isUnconnected = Boolean(account.unconnected && account.minimumDeposit && accountBalance >= account.minimumDeposit)
  const isDepositNeeded = Boolean(account.unconnected && accountBalance === 0)
  const isUnapproved = !account.unconnected && !account.isPammInvestorAccountApprovedByMoneyManager

  const handleClick = () => {
    if (account != null && (isUnconnected || isUnapproved || isDepositNeeded)) {
      dispatch({type: ActionType.Click})
    } else {
      invariant(account.id, 'Account id is required')
      toPammPortal(account.id)
    }
  }

  return (
    <>
      <PammInvestorAccountCard
        account={account}
        company={company}
        isDepositNeeded={isDepositNeeded}
        isUnapproved={isUnapproved}
        restAccounts={restAccounts}
        onClick={handleClick}
      />
      <PammInvestorMinimumDepositRequiredPopup
        account={account}
        company={company}
        onClose={closeModals}
        open={showMinimumDepositRequiredPopup}
      />
      <PammInvestorPendingPopup
        account={account}
        company={company}
        onClose={closeModals}
        open={showPendingPopup}
      />
    </>
  )
}
